import { render, staticRenderFns } from "./JobfairCreationSuccess.vue?vue&type=template&id=99196100&scoped=true"
import script from "./JobfairCreationSuccess.vue?vue&type=script&lang=js"
export * from "./JobfairCreationSuccess.vue?vue&type=script&lang=js"
import style0 from "./JobfairCreationSuccess.vue?vue&type=style&index=0&id=99196100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99196100",
  null
  
)

export default component.exports